import { ca } from '@cian/analytics';

export function trackAllFeaturesClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'Click',
    label: 'features_jk',
    useLastProducts: true,
  });
}
